import React , {Component} from 'react';
import {
    Page  , Link
} from 'framework7-react';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";

class Contact extends Component{

    constructor(props){
        super(props)
        this.state = {

        }
    }


    onPageBeforeIn(){
        this.props.toolbar(true)
    }


    render(){

        return(
            <Page name="ordersList" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link href="/" id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        تماس با ما
                    </div>
                </div>
                <div id="inner-header-separator" />

                <div id="contact">

                    <img src="https://www.lavefood.com/webappassets/images/logo.svg" id="logo" alt=""/>

                    <div id="description">
                        ما تلاش می کنیم زندگی رو در محیط اطرافمون بهتر کنیم.
                        فکر می کنیم "لوه" قدم کوچیکیه که می تونه مارو به این هدف بزرگ نزدیک کنه. یعنی امیدواریم که همینطور باشه!
                    </div>


                    <div className="item-header">
                        تماس با ما
                    </div>

                    <Link href="tel:09055118434" className="item" external target="_blank">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/notification-2-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                پشتیبانی تلفنی
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />*/}
                    </Link>


                    <Link href="https://t.me/applave" className="item" external target="_blank">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/notification-2-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                پشتیبانی آنلاین
                            </div>
                        </div>
                        {/*<img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />*/}
                    </Link>


                    {/*<Link href="tel:09119351172" className="item" external target="_blank">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/notification-2-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                اینستاگرام
                            </div>
                        </div>
                        <img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />
                    </Link>*/}

                    {/*<Link href="tel:09119351172" className="item" external target="_blank">
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/notification-2-line.svg" />

                        <div className="text">
                            <div className="sub-title">
                                وبسایت
                            </div>
                        </div>
                        <img className="icon-action" src="https://www.lavefood.com/webappassets/images/arrows_left.svg" />
                    </Link>*/}

                    {/*<Link id="footer" href="http://shahrara.net" target="_blank" external>

                        <img className="icon" src="https://www.lavefood.com/webappassets/images/shahrara.svg" />
                        <span className="title">
                            Design & Developed by
                        </span>
                    </Link>*/}

                </div>









            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(Contact);